function sineInOut(t) {
  return -0.5 * (Math.cos(Math.PI*t) - 1);
}

module.exports = sineInOut;


// WEBPACK FOOTER //
// ./project/client/src/core/vendor/eases/sine-in-out.js